import { render, staticRenderFns } from "./HolidaySidebar.vue?vue&type=template&id=eb6c3ce2&"
import script from "./HolidaySidebar.vue?vue&type=script&lang=js&"
export * from "./HolidaySidebar.vue?vue&type=script&lang=js&"
import style0 from "./HolidaySidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports